export default {
  INGENICO: 'ingenico',
  CUSTOMER: 'acquirer',
  CUSTOMER_NEW: 'customer',
  MERCHANT: 'merchant'
};
